<script setup lang="ts">
/**
 * The panel's failure state.
 *
 * It takes its copy as a prop rather than translating anything itself, because it
 * is rendered in two very different situations: inside the app, where the brand's
 * locale is known and the string is translated; and from `main.ts` before any
 * locale could have been negotiated, when the loader was misconfigured and the
 * only person who can act on the message is the developer who installed it.
 *
 * The optional action — a retry button — is the default slot.
 *
 * It is a paragraph and not an error trace. A visitor on a shop's checkout page
 * should never see a stack, and there is nothing here they could do with one.
 */
defineProps<{ readonly detail: string }>();
</script>

<template>
  <div class="ow-notice" role="status">
    <svg class="ow-notice__icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path
        fill="currentColor"
        d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zm0 5a1 1 0 0 1 1 1v5a1 1 0 1 1-2 0V8a1 1 0 0 1 1-1zm0 10.5a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5z"
      />
    </svg>
    <p class="ow-notice__text">{{ detail }}</p>
    <slot />
  </div>
</template>
